import { useState } from 'react';
import { voucherApi } from '@utils/api';

export function useVoucher({ openPopup }) {
  const [userProfile, setUserProfile] = useState({
    friend_id: '',
    player_name: ''
  })
  const [voucherHistory, setVoucherHistory] = useState([])

  const loginUser = async (friendId) => {
    try {
      const res = await voucherApi.post('extra/web/user/login',{
        friend_id: friendId
      });

      const code = res.data?.code

      if (code !== 0) {
        throw code
      }

      setUserProfile(res.data?.user)
      return true
    } catch (error) {
      console.error(error)
      if (error === 1 || error === '1') {
        openPopup('LoginFailed-1')
      } else {
        openPopup('LoginFailed-2')
      }
      return false
    }
  }

  const redeemVoucher = async (voucherCode) => {
    try {
      const res = await voucherApi.post('/extra/web/voucher/redeem',{
        friend_id: userProfile.friend_id,
        voucher_code: voucherCode
      });

      const code = res.data?.code

      if (code !== 0) {
        throw code
      } else {
        openPopup('ExchangeSuccess')
      }

      return true
    } catch (error) {
      console.error(error);
      if (error === 2 || error === '2') {
        openPopup('ExchangeFailed-2')
      } else if (error === 3 || error === '3') {
        openPopup('ExchangeFailed-3')
      } else if (error === 6 || error === '6') {
        openPopup('ExchangeFailed-6')
      }
      return false
    }
  }

  const getVoucherHistory = async () => {
    try {
      const res = await voucherApi.post('extra/web/user/voucherHistory', {
        friend_id: userProfile.friend_id
      });
      setVoucherHistory(res.data?.history)
    } catch (error) {
      console.error(error)
    }
  }

  return {
    voucherHistory,
    userProfile,
    redeemVoucher,
    getVoucherHistory,
    loginUser
  };
} 